import './globals';
import React from 'react';
import ReactDOM from 'react-dom';

import './assets/css/style.css';
import './assets/css/toastify.css';
import App from './containers/App';

ReactDOM.render(<App />, document.getElementById('root'));
